import { render, staticRenderFns } from "./OPDetailCustomer.vue?vue&type=template&id=767d8c3c&scoped=true&"
import script from "./OPDetailCustomer.vue?vue&type=script&lang=js&"
export * from "./OPDetailCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d8c3c",
  null
  
)

export default component.exports